import React, { useState, useCallback } from "react";
import { navigate } from "gatsby";
import PropTypes from "prop-types";

import * as styles from "./CustomPageHeader.module.scss";
import HomepageHeaderSection from "./HomepageHeaderSection";
import RegularPageHeaderSection from "./RegularPageHeaderSection";

const CustomPageHeader = ({ description, image, title, label }) => {
  const whoYouAreSection = "#let-us-know-who-you-are";
  const homepageTitle = "Start with Legion Design System";
  const [showModal, setShowModal] = useState(false);

  const toggleModal = useCallback(() => setShowModal((prev) => !prev), []);
  const navigateUrl = useCallback(() => navigate(whoYouAreSection), []);

  return (
    <div className={`${styles["bg"]} ${styles["maxWidthFull"]}`}>
      {title === homepageTitle ? (
        <HomepageHeaderSection
          description={description}
          image={image}
          label={label}
          navigateUrl={navigateUrl}
          showModal={showModal}
          title={title}
          toggleModal={toggleModal}
        />
      ) : (
        <RegularPageHeaderSection
          description={description}
          image={image}
          label={label}
          title={title}
        />
      )}
    </div>
  );
};

const stringOrNode = PropTypes.oneOfType([PropTypes.string, PropTypes.node]);

CustomPageHeader.propTypes = {
  image: stringOrNode,
  description: stringOrNode,
  label: stringOrNode,
  title: stringOrNode,
};

export default CustomPageHeader;